import { ActionBlock, ActionRunner } from '@scarybeasties/phaser-framework-core/modules';
import { Level, LevelName } from './levels/level';
import { LevelUtil } from './levels/LevelUtil';
import { RunSettingsHandler } from './RunSettingsHandler';
import { GameLayers } from './GameLayers';
import Vector2 = Phaser.Math.Vector2;
import { GameDataHandler } from '../game/GameDataHandler';
import GameUI from "../scenes/GameUI";
import Tile, {TileType, TileTypeValues} from "../game/Tile";
import Bumper from "../prefabs/tiles/Bumper";
import Taz from "../prefabs/tiles/Taz";
import disable = Phaser.Display.Canvas.Smoothing.disable;
import Critter from "../prefabs/tiles/Critter";

export interface Circle {
  center:Vector2,
  size:number
}

export class LevelManager {
  protected scene: Phaser.Scene;
  protected currentLevel: Level;
  protected camera: Phaser.Cameras.Scene2D.Camera | undefined;
  protected gameLayers: GameLayers | undefined;
  private player!:Taz;
  public mapLeftBorder:number=0;
  public mapRightBorder:number=0;
  public mapTopBorder:number=0;
  public mapBottomBorder:number=0;
  private tiles: Tile[] = [];
  private bumpers: Bumper[] = [];
  private critters: Critter[] = [];
  private totalTiles : integer = 0;
  private bumpersRaised:boolean = false;

  public static events = {
    BlockBroken:"BlockBroken",
    UpdateScore:"UpdateScore",
  } as const;

  constructor(scene: Phaser.Scene, level: Level) {
    this.scene = scene;
    this.currentLevel = level;

  }

  get CurrentLevel(): Level {
    return this.currentLevel;
  }

  get Player(): Taz
  {
    return this.player;
  }

  get Friction(): number
  {
    return this.currentLevel.friction;
  }

  get TotalTiles():integer
  {
    return this.totalTiles;
  }

  public init(
    camera: Phaser.Cameras.Scene2D.Camera,
    gameLayers: GameLayers
  ) {
    this.camera = camera;
    this.gameLayers = gameLayers;

    this.scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);
    this.scene.events.emit(LevelManager.events.UpdateScore);
    this.scene.events.emit(LevelManager.events.BlockBroken);
    this.LoadTileMap();
  }

  public randomTile():Tile{
    return this.tiles[Math.floor(Math.random()*this.tiles.length)];
  }

  public destroyedAllTiles():boolean{
    return this.tiles.length == 0;
  }

  private GetPropertyFromLevel(json:any, name:string)
  {
    for(let i = 0; i < json.data.properties.length; ++i)
    {
      if(json.data.properties[i].name == name)
      {
        return json.data.properties[i].value;
      }
    }
  }

  private findKeyInProperties(properties:any[], name:string)
  {
    for(let i = 0; i < properties.length; i++)
    {
      if(properties[i].name == name)
      {
        return properties[i];
      }
    }
    return null;
  }

  private LoadTileMap()
  {
    let background = this.scene.add.sprite(960,384,this.currentLevel.levelBackgroundAtlas,this.currentLevel.levelBackground);
    this.gameLayers?.backgroundLayer.add(background);

    let backgroundBox = this.scene.add.sprite(963,389+20,this.currentLevel.levelBackgroundAtlas,this.currentLevel.gameplayBackground);
    this.gameLayers?.backgroundLayer.add(backgroundBox);


    let json = this.scene.cache.tilemap.get(this.currentLevel.levelMap);
    console.log(this.currentLevel.levelMap,json);
    
    let layers = json.data.layers;
    let tileWidth = json.data.tilewidth;
    let tileHeight = json.data.tileheight;

    let mapWidth = json.data.width;
    let mapHeight = json.data.height;

    let centerX = (tileWidth/2) + (1920/2)- ((mapWidth*tileWidth)/2);
    let centerY = (tileHeight/2) + (768/2) - ((mapHeight*tileHeight)/2) + 20;

    this.mapLeftBorder = centerX;
    this.mapRightBorder = centerX+(mapWidth*tileWidth)-tileWidth;
    this.mapTopBorder = centerY;
    this.mapBottomBorder = centerY+(mapHeight*tileHeight)-tileHeight;
    let tileCount:integer = 0;

    for(let i = 0; i < layers.length; i++)
    {
      let x = 0;
      let y = 0;

      let data = layers[i].data;
      let layerName = layers[i].name;

        for (let ii = 0; ii < data.length; ++ii) {
          if (data[ii] != 0) {

            let props;
            let tileImage;
            for (let iii = 0; iii < json.data.tilesets[0].tiles.length; ++iii) {
              if (json.data.tilesets[0].tiles[iii].id == data[ii] - 1) {
                props = json.data.tilesets[0].tiles[iii].properties;
                tileImage = json.data.tilesets[0].tiles[iii].image.replace(/^.*[\\\/]/, '');
                break;
              }
            }
                        
            if (layerName == "Player") {
              this.player = new Taz(this.scene,this,centerX + (x * tileWidth), centerY + (y * tileHeight));
              this.scene.add.existing(this.player);
              this.gameLayers?.actionLayer.add(this.player);
            }
            else
            {
              let tilePrefab: TileTypeValues = TileType.Default;
              for(let iii = 0; iii < props.length; ++iii)
              {
                if(props[iii].name == "TileType")
                {
                  tilePrefab = props[iii].value;
                }
              }

              // console.log(props);
              
              let t = LevelUtil.getTile(tilePrefab, this.scene, this, centerX + (x * tileWidth), centerY + (y * tileHeight), props, json.data.tilesets[0].name, tileImage);
              if (t != undefined) {
                let tile: Tile = t;
                this.scene.add.existing(tile);
                //let tile = this.scene.add.sprite(centerX+(x * tileWidth), centerY + (y * tileHeight), "game", frame);
                this.gameLayers?.actionLayer.add(tile);

                  
                if (layerName == "Bumpers") {
                  this.bumpers.push(tile as Bumper);
                }else if (layerName == "Critters") {
                  this.critters.push(tile as Critter);
                } else {
                  tile.data = new Phaser.Data.DataManager(tile);
                  this.tiles.push(tile);
                  tileCount++;
                }
              }
            }
          }
          x++;
          if (x >= mapWidth) {
            x = 0;
            y++;
          }
        }


    }
    this.totalTiles = tileCount;

  }

  public hitObjects(x:number, y:number, size:number, ignoreTile?:Tile)
  {
    let collisionData:{normal:Vector2,point:Vector2, tile:Tile}[] = [];
    let collisions:Tile[] = [];

    let curr:Vector2 = new Vector2(x,y);
    let circle: Circle = new class implements Circle {
        center: Phaser.Math.Vector2 = new Phaser.Math.Vector2(x, y);
        size: number = size;
    }

      for (let ii = 0; ii < this.tiles.length; ++ii) {
        let tile:Tile = this.tiles[ii];
        if(tile != ignoreTile) {

          if (this.circleSpriteCollide(circle, tile)) {
            let distX = Math.abs(curr.x - tile.x);
            let distY = Math.abs(curr.y - tile.y);

            if (distX > distY) {
              if (x < tile.x) {
                collisionData.push({normal: new Vector2(1, 0), point: curr, tile: tile});
              } else if (x > tile.x) {
                collisionData.push({normal: new Vector2(-1, 0), point: curr, tile: tile});
              }
            } else {
              if (y < tile.y) {
                collisionData.push({normal: new Vector2(0, 1), point: curr, tile: tile});
              } else if (y > tile.y) {
                collisionData.push({normal: new Vector2(0, -1), point: curr, tile: tile});
              }
            }
            if(collisions.indexOf(tile) == -1) {
              collisions.push(tile);
            }
          }
        }
      }


    if(collisions.length > 0) {
      this.destroyLastCollisions(collisions);
    }
  }

  public hitObject(x:number, y:number, size:number, prevX:number, prevY:number, destroyOnHit:boolean = true)
  {
    let collisionData:{normal:Vector2,point:Vector2, tile:Tile}[] = [];
    let collisions:Tile[] = [];

    let prev:Vector2 = new Vector2(prevX,prevY);
    let curr:Vector2 = new Vector2(x,y);
    let dist = curr.distance(prev);
    let steps:integer = 1;

    if(dist > size)
    {
      steps = Math.round(dist/size);
    }

    for(let i = 0; i < steps; ++i) {
      let lerp = prev.lerp(curr,(i+1)/steps);
      let circle: Circle = new class implements Circle {
        center: Phaser.Math.Vector2 = new Phaser.Math.Vector2(lerp.x + size / 2, lerp.y + size / 2);
        size: number = size;
      }

      for (let ii = 0; ii < this.tiles.length; ++ii) {
        let tile:Tile = this.tiles[ii];

        if (this.circleSpriteCollide(circle, tile)) {
          let distX = prevX - tile.x;
          let distY = prevY - tile.y;
          let dir:Vector2 = new Vector2(distX, distY).normalize();
          let point:Vector2 = new Vector2(tile.x,tile.y);
          point.x += dir.x * (tile.width/2 + size/2)*1.1;
          point.y += dir.y * (tile.height/2 + size/2)*1.1;

          if (Math.abs(distX) > Math.abs(distY)) {
            if (x < tile.x) {
              collisionData.push({normal:new Vector2(1, 0),point:point,tile:tile});
            } else if (x > tile.x) {
              collisionData.push({normal:new Vector2(-1, 0),point:point,tile:tile});
            }
          } else {
            if (y < tile.y) {
              collisionData.push({normal:new Vector2(0, 1),point:point,tile:tile});
            } else if (y > tile.y) {
              collisionData.push({normal:new Vector2(0, -1),point:point,tile:tile});
            }
          }
          collisions.push(tile);
        }
        if(collisions.length > 0)
        {
          break;
        }
      }
      if(collisions.length > 0)
      {
        break;
      }
    }

    if(collisions.length > 0) {
      if(destroyOnHit) {
        this.destroyLastCollisions(collisions);
      }
      return collisionData[0];
    }
    return null;
  }

  public toggleBumpers()
  {
    for (let ii = 0; ii < this.bumpers.length; ++ii) {
      this.bumpers[ii].toggleAvailable();
    }
  }

  public resetBumpers()
  {
    for (let ii = 0; ii < this.bumpers.length; ++ii) {
      this.bumpers[ii].resetAvailable();
    }
  }

  public hasBumpers() : boolean
  {
    return this.bumpers.length > 0;
  }

  public hitBumper(x:number,y:number, size:number, prevX:number, prevY:number)
  {
    let collisionData:{normal:Vector2,point:Vector2,tile:Tile, wasDownLastFrame:boolean}[] = [];
    let collisions:Phaser.GameObjects.Sprite[] = [];

    let prev:Vector2 = new Vector2(prevX,prevY);
    let curr:Vector2 = new Vector2(x,y);
    let dist = curr.distance(prev);
    let steps:integer = 1;

    if(dist > size)
    {
      steps = Math.round(dist/size);
    }

    for(let i = 0; i < steps; ++i) {
      let lerp = prev.lerp(curr,(i+1)/steps);
      let circle: Circle = new class implements Circle {
        center: Phaser.Math.Vector2 = new Phaser.Math.Vector2(lerp.x + size / 2, lerp.y + size / 2);
        size: number = size;
      }

      for (let ii = 0; ii < this.bumpers.length; ++ii) {
        let tile = this.bumpers[ii];

        if(!tile.Available)
        {
          continue;
        }
        if (this.circleSpriteCollide(circle, tile)) {
          let distX = prevX - tile.x;
          let distY = prevY - tile.y;
          let dir:Vector2 = new Vector2(distX, distY).normalize();
          let point:Vector2 = new Vector2(tile.x,tile.y);

          if(tile.hitTile())
          {
            point.x += dir.x * ((tile.width*1.2)/2 + size/2);
            point.y += dir.y * ((tile.width*1.2)/2 + size/2);
            collisionData.push({normal:dir,point:point,tile:tile, wasDownLastFrame:(tile as Bumper).wasDownLastFrame});
            collisions.push(tile);
          }

          break;
        }
      }
      if(collisions.length > 0)
      {
        break;
      }
    }

    if(collisions.length > 0) {
      return collisionData[0];
    }
    return null;
  }

  public hitCritter(x:number,y:number, size:number, prevX:number, prevY:number)
  {
    let collisionData:{critter:Critter}[] = [];
    let collisions:Tile[] = [];

    let prev:Vector2 = new Vector2(prevX,prevY);
    let curr:Vector2 = new Vector2(x,y);
    let dist = curr.distance(prev);
    let steps:integer = 1;

    if(dist > size)
    {
      steps = Math.round(dist/size);
    }

    for(let i = 0; i < steps; ++i) {
      let lerp = prev.lerp(curr,(i+1)/steps);
      let circle: Circle = new class implements Circle {
        center: Phaser.Math.Vector2 = new Phaser.Math.Vector2(lerp.x + size / 2, lerp.y + size / 2);
        size: number = size;
      }

      for (let ii = 0; ii < this.critters.length; ++ii) {
        let critter = this.critters[ii];

        let tileCircle: Circle = new class implements Circle {
          center: Phaser.Math.Vector2 = new Phaser.Math.Vector2(critter.x+critter.width/2, critter.y+critter.width/2);
          size: number = critter.width;
        }

        if (this.circleSpriteCollide(circle, critter)) {
          collisionData.push({critter:critter});
          collisions.push(critter);
          // critter.hitTile();
          // let index = this.critters.indexOf(critter);
          // this.critters.splice(index,1);
          break;
        }
      }
    }

    if(collisionData.length > 0) {
      this.destroyLastCollisions(collisions);
      return collisionData[0];
    }
    return null;
  }

  movingCircleSpriteCollide(a:Circle,moveA:Vector2,s:Phaser.GameObjects.Sprite) : boolean
  {
    let envelope:Circle = a;
    let halfMoveA = moveA.clone();
    halfMoveA.divide(new Vector2(2,2));
    let moveDistance = moveA.length();
    let halfMoveAPlusCenter = halfMoveA.clone();
    envelope.center = halfMoveAPlusCenter.add(a.center);
    envelope.size  = a.size + moveDistance/2;

    if(this.circleSpriteCollide(envelope,s))
    {
      let epsilon = 1/32;
      let minimumMoveDistance = Math.max(a.size/4,epsilon);
      if(moveDistance < minimumMoveDistance)
      {
        return true;
      }

      envelope.size = a.size;
      return this.movingCircleSpriteCollide(a,halfMoveA,s) || this.movingCircleSpriteCollide(envelope,halfMoveA,s)
    }
    else return false;
  }

  circlePointCollide(c:Circle, p:Vector2)
  {
    let clone = p.clone();
    let distance:Vector2 = clone.subtract(c.center);
    return distance.length() <= c.size;
  }

  circleSpriteCollide(c:Circle,s:Phaser.GameObjects.Sprite)
  {
    let clamped:Vector2 = this.clampOnSprite(c.center,s);
    return this.circlePointCollide(c,clamped);
  }

  circleCircleCollide(c:Circle, c1:Circle)
  {
    let radisuSum:number = c.size + c1.size;
    let cClone:Vector2 = c.center.clone();
    let distance:Vector2 = cClone.subtract(c1.center)
    return distance.length() < radisuSum;
  }

  clampOnSprite(p:Vector2, s:Phaser.GameObjects.Sprite)
  {
    let clamp:Vector2 = new Phaser.Math.Vector2(this.clampOnRange(p.x,s.x,s.x+s.width/2),
      this.clampOnRange(p.y,s.y,s.y+s.height/2));

    return clamp;
  }

  clampOnRange(x:number,min:number,max:number)
  {
    if(x < min)
    {
      return min;
    }
    else if(max < x)
    {
      return max;
    }
    else
    {
      return x;
    }
  }

  public pointOutsidePlayArea(x:number, y:number)
  {
    if(x < this.mapLeftBorder ||
      x > this.mapRightBorder ||
      y < this.mapTopBorder ||
      y > this.mapBottomBorder)
    {
      return true;
    }
  }

  public destroyLastCollisions(collisions:Tile[])
  {
    for(let i = 0; i < collisions.length; ++i )
    {
      //check the last time a collision happened on this tile.
      //Need to wait until a few frames have elapsed so that
      //if the player overlaps the block for two frames, it doesnt destroy a 2 health block instantly.
      //Delaying for X time gives it enough buffer to let the player bounce off and give the illusion of a block with
      //extra health.

      if(collisions[i].hitTile())
      {
        this.scene.events.emit(LevelManager.events.UpdateScore,collisions[i]);

        let index = this.tiles.indexOf(collisions[i]);
        if (index > -1) {
          this.tiles.splice(index, 1);
          this.scene.events.emit(LevelManager.events.BlockBroken,collisions[i]);
        }else
        {
          index = this.critters.indexOf(<Critter>collisions[i]);
          if (index > -1) {
            this.critters.splice(index, 1);
          }
        }

        if(collisions[i].canExplode())
        {
          this.hitObjects(collisions[i].x,collisions[i].y,collisions[i].ExplosionRadius,collisions[i]);
        }
      }
    }
  }

  public changeLevel(level: Level) {
    this.currentLevel = level;
  }

  public setupLevel() {
    this.clearLevel();
  }

  public startLevel() {
  }

  public updateLevel(time: number, delta: number) {
    for(let i = 0; i < this.tiles.length; ++i)
    {
      this.tiles[i].updateTile(time,delta);
    }
    for(let i = 0; i < this.bumpers.length; ++i)
    {
      this.bumpers[i].updateTile(time,delta);
    }
    for(let i = 0; i < this.critters.length; ++i)
    {
      if(this.critters[i] != undefined) {
        this.critters[i].updateLoop(time, delta);
      }
    }
  }

  public clearLevel() {}

  public setEndpoint(newEndpoint: number) {
    // this.endPointX = newEndpoint;
  }

  // Tear down.
  public endLevel() {}

  protected shutdown() {
  }
}
